<template>
  <div
    ref="graphicEl"
    class="element timer-wrapper text"
    :class="[element.cssClasses]"
    :style="[getBasicStyles, getTextShadowStyles, getTransformStyles]"
  >
    <div
      class="timer-widget"
      :class="[element.animationInStyle, element.animationOutStyle, 'vertical-' + element.verticalAlign]"
      :style="{ display: 'flex', flexDirection: 'column' }"
    >
      <transition
        appear
        :mode="transitionMode"
        :enter-active-class="'animated ' + animationIn"
        :leave-active-class="'animated ' + animationOut"
        @before-enter="beforeEnter"
        @after-enter="afterEnter"
        @before-leave="beforeLeave"
        @after-leave="afterLeave"
      >
        <div
          v-if="element.visible"
          :key="animKey"
          class="animated-element"
          :style="getAnimationStyles"
          :class="getLoopingClass"
        >
          <div
            v-if="element.showEndDateTime && isRelative"
            :style="[
              getTextStyles('endDateText'),
              { flexGrow: 1, display: 'flex', justifyContent: 'center', whiteSpace: 'nowrap' },
            ]"
            class="end-date"
          >
            {{ endDateTime }}
          </div>
          <div
            :style="getTimerStyles()"
            class="timer"
          >
            <!-- DAYS -->
            <div
              v-if="element.showDays"
              :style="getTimeStyles()"
              class="days"
            >
              <div
                v-if="element.style === 'Basic'"
                :style="[getTextStyles('timerText')]"
                class="digit"
              >
                {{ days }}
              </div>
              <div
                v-if="element.style === 'Flip clock'"
                :style="[getTextStyles('timerText'), getFlipStyles()]"
                class="splitflap digit"
              >
                <div
                  :style="getFlapStyles('newTop')"
                  class="half new-top"
                >
                  {{ days }}
                </div>
                <div
                  :style="getFlapStyles('newBottom')"
                  class="half new-bottom flip1"
                >
                  {{ days }}
                </div>
                <div
                  :style="getFlapStyles('oldTop')"
                  class="half old-top flip2"
                />
                <div
                  :style="getFlapStyles('oldBottom')"
                  class="half old-bottom"
                />
              </div>
              <div
                v-if="element.showUnits"
                :style="getTextStyles('unitText')"
                class="unit-label"
              >
                {{ element.daysLabel }}
              </div>
            </div>
            <div
              v-if="!element.showUnits && element.showDays"
              :style="[getTextStyles('timerText'), getDividerStyles()]"
            >
&nbsp;
            </div>
            <!-- HOURS -->
            <div
              v-if="element.showHours"
              :style="getTimeStyles()"
              class="hours"
            >
              <div
                v-if="element.style === 'Basic'"
                :style="[getTextStyles('timerText')]"
                class="digit"
              >
                {{ hours }}
              </div>
              <div
                v-if="element.style === 'Flip clock'"
                :style="[getTextStyles('timerText'), getFlipStyles()]"
                class="splitflap digit"
              >
                <div
                  :style="getFlapStyles('newTop')"
                  class="half new-top"
                >
                  {{ hours }}
                </div>
                <div
                  :style="getFlapStyles('newBottom')"
                  class="half new-bottom flip1"
                >
                  {{ hours }}
                </div>
                <div
                  :style="getFlapStyles('oldTop')"
                  class="half old-top flip2"
                />
                <div
                  :style="getFlapStyles('oldBottom')"
                  class="half old-bottom"
                />
              </div>
              <div
                v-if="element.showUnits"
                :style="getTextStyles('unitText')"
                class="unit-label"
              >
                {{ element.hoursLabel }}
              </div>
            </div>
            <div
              v-if="!element.showUnits && element.showHours && element.showMinutes"
              :style="[getTextStyles('timerText'), getDividerStyles()]"
            >
              :
            </div>
            <!-- MINUTES -->
            <div
              v-if="element.showMinutes"
              :style="getTimeStyles()"
              class="minutes"
            >
              <div
                v-if="element.style === 'Basic'"
                class="digit"
                :style="[getTextStyles('timerText')]"
              >
                {{ minutes }}
              </div>
              <div
                v-if="element.style === 'Flip clock'"
                :style="[getTextStyles('timerText'), getFlipStyles()]"
                class="splitflap digit"
              >
                <div
                  :style="getFlapStyles('newTop')"
                  class="half new-top"
                >
                  {{ minutes }}
                </div>
                <div
                  :style="getFlapStyles('newBottom')"
                  class="half new-bottom flip1"
                >
                  {{ minutes }}
                </div>
                <div
                  :style="getFlapStyles('oldTop')"
                  class="half old-top flip2"
                />
                <div
                  :style="getFlapStyles('oldBottom')"
                  class="half old-bottom"
                />
              </div>
              <div
                v-if="element.showUnits"
                :style="getTextStyles('unitText')"
                class="unit-label"
              >
                {{ element.minutesLabel }}
              </div>
            </div>
            <div
              v-if="!element.showUnits && element.showMinutes && element.showSeconds"
              :style="[getTextStyles('timerText'), getDividerStyles()]"
            >
              :
            </div>
            <!-- SECONDS -->
            <div
              v-if="element.showSeconds"
              :style="getTimeStyles()"
              class="seconds"
            >
              <div
                v-if="element.style === 'Basic'"
                :style="[getTextStyles('timerText')]"
                class="digit"
              >
                {{ seconds }}
              </div>
              <div
                v-if="element.style === 'Flip clock'"
                :style="[getTextStyles('timerText'), getFlipStyles()]"
                class="splitflap digit"
              >
                <div
                  :style="getFlapStyles('newTop')"
                  class="half new-top"
                >
                  {{ seconds }}
                </div>
                <div
                  :style="getFlapStyles('newBottom')"
                  class="half new-bottom flip1"
                >
                  {{ seconds }}
                </div>
                <div
                  :style="getFlapStyles('oldTop')"
                  class="half old-top flip2"
                />
                <div
                  :style="getFlapStyles('oldBottom')"
                  class="half old-bottom"
                />
              </div>
              <div
                v-if="element.showUnits"
                :style="getTextStyles('unitText')"
                class="unit-label"
              >
                {{ element.secondsLabel }}
              </div>
            </div>
            <div
              v-if="!element.showUnits && element.showMilliseconds"
              :style="[getTextStyles('timerText'), getDividerStyles()]"
            >
              .
            </div>
            <div
              v-if="element.showMilliseconds"
              :style="getTimeStyles()"
            >
              <div
                class="digit"
                :style="[getTextStyles('timerText')]"
              >
                {{ milliseconds }}
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import graphicsMixins from '../../../mixins/graphics-mixins';

/**
 * Pad numbers with leading zero if one digit.
 * @param {number} int - The number to pad.
 * @returns {string} - The padded number as a string.
 */
const padNumber = (val = 0) => (val < 10 ? `0${val.toString()}` : val.toString());

export default {
  mixins: [graphicsMixins],
  data() {
    // durations are in seconds by default, unless this.element.showMilliseconds === true
    return {
      counter: this.getInitialCounter(), // Total time passed while the timer is running.
      ticker: 0, // Total time counted since last pause/reset.

      intervalId: null, // keep track of the interval which is controlling the timer.
    };
  },

  computed: {
    /**
     * Calculate total number of seconds for starting time,
     * set via preview fields in Producer.
     */
    previewSeconds() {
      const {
        dayPreview: d = 0,
        hourPreview: h = 0,
        minutePreview: m = 0,
        secondPreview: s = 0,
      } = this.element;

      if (this.isCountdown) {
        return 0;
      }

      // If we are counting up, we add the initial total seconds to the duration.
      return (d * 86400) + (h * 3600) + (m * 60) + s;
    },

    days() {
      if (!this.element.showDays) {
        return 0;
      }

      const seconds = Math.floor(this.duration / 1e3) + this.previewSeconds;
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);
      return padNumber(days);
    },

    hours() {
      if (!this.element.showHours) {
        return 0;
      }

      const seconds = Math.floor(this.duration / 1e3) + this.previewSeconds;
      const minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);

      hours = this.element.showDays ? Math.floor(hours % 24) : hours;

      // If we also show days, then % the duration to get hours,
      // otherwise show total hours.
      // We also add whatever the hourPreview is, since that's the starting point,
      // contrary to how the name sounds.
      return padNumber(hours);
    },

    minutes() {
      if (!this.element.showMinutes) {
        return 0;
      }

      const seconds = Math.floor(this.duration / 1e3) + this.previewSeconds;
      let minutes = Math.floor(seconds / 60);

      minutes = this.element.showHours ? Math.floor(minutes % 60) : minutes;

      // If we also show hours, then % the duration to get minutes,
      // otherwise show total minutes.
      // We also add whatever the minutePreview is, since that's the starting point,
      // contrary to how the name sounds.
      return padNumber(minutes);
    },

    seconds() {
      if (!this.element.showSeconds) {
        return 0;
      }

      let seconds = Math.floor(this.duration / 1e3) + this.previewSeconds;

      // If we also show minutes, then % the duration to get seconds,
      // otherwise show total seconds.
      seconds = this.element.showMinutes ? Math.floor(seconds % 60) : seconds;
      return padNumber(seconds);
    },

    milliseconds() {
      return this.duration % 1e3;
    },

    /**
     * Returns true if timer should count down, instead of up (a.k.a. stopwatch or count up).
     * @returns {boolean}
     */
    isCountdown() {
      return this.element.timerType === 'Countdown';
    },

    /**
     * Returns true if the timer is relative to a specific date.
     * @returns {boolean}
     */
    isRelative() {
      return this.element.counterFormat === 'Date & Time';
    },

    duration() {
      return this.isCountdown
        ? Math.max(this.counter - this.ticker, 0)
        : this.counter + this.ticker;
    },

    animKey() {
      const {
        hourPreview: h,
        minutePreview: m,
        secondPreview: s,
        dateTime,
      } = this.element;

      // Using the "preview" for keys since those are start values
      return dateTime || `${h}:${m}:${s}`;
    },

    endDateTime() {
      const { dateTime, endDateTimeFormat } = this.element;

      const now = dayjs();
      const end = dayjs(dateTime);

      if (dateTime && end > now) {
        return end.format(endDateTimeFormat);
      }

      return null;
    },

    getTextShadowStyles() {
      const {
        textShadow,
        textShadowX,
        textShadowY,
        textShadowBlur,
      } = this.element;

      if (!textShadow) {
        return {};
      }

      const textShadowColor = (
        this.element.data?.dataValues?.textShadowColor
        ?? this.element.textShadowColor
      );

      return {
        textShadow: `${textShadowX}px ${textShadowY}px ${textShadowBlur}px ${textShadowColor}`,
      };
    },
  },

  watch: {
    // When the entire graphic is updated, we want to make sure timers are reset.
    // Main use case if user switching between the same graphic, duplicated in the timeline.
    'graphic.timeline_id': function elementChangeHandler() {
      if (this.element.duration || this.element.playTimer) {
        this.resetDuration();
        return;
      }

      this.timer();

      if (this.isRelative && this.isCountdown) {
        // Prevent negative values for countdown date & time timer on reset
        this.resetDuration();

        if (this.ticker <= 0) {
          this.ticker = 0;
          this.element.playTimer = false;
        }
      } else {
        this.resetTimer();
      }
    },

    actions: {
      deep: true,
      handler(newVal, prevVal) {
        const [action] = newVal;

        if (action.type !== 'timer widget' || action.elementId !== this.element.id) {
          return;
        }

        switch (action.value) {
          case 'pause':
          case 'start': {
            // Necessary to set `playTimer` here, since it won't be updated yet.
            this.element.playTimer = action.value === 'start';
            this.timer();
            break;
          }

          case 'reset': {
            this.resetTimer();
            break;
          }

          default: {
            console.log('Unknown action:', action); // eslint-disable-line no-console
            break;
          }
        }
      },
    },
  },

  mounted() {
    if (this.element.duration || this.element.playTimer) {
      this.resetDuration();
      this.timer();
    } else if (this.isRelative && this.isCountdown) {
      // prevent negative values for countdown date & time timer on reset
      this.resetDuration();

      if (this.ticker <= 0) {
        this.ticker = 0;
        this.element.playTimer = false;
      }
    } else {
      this.resetTimer();
    }

    // if the timer type, preview settings, display settings, or datepicker are changed, update
    this.$watch(() => [
      this.element.hourPreview,
      this.element.minutePreview,
      this.element.secondPreview,
      this.element.timerFormat,
      this.element.counterFormat,
      this.element.dateTime,
    ], (newValues, oldValues) => {
      // The for loop is necessary for when we update this component from tgb-live/producer
      for (let i = 0; i < newValues.length; i += 1) {
        if (newValues[i] !== oldValues[i]) {
          if (!this.isRelative && newValues[5] !== oldValues[5]) {
            // disregard discrepancies in dateTime, if the counterFormat doesn't include dateTime
            return;
          }

          this.element.playTimer = false; // stop playing if any settings change
          this.resetTimer(); // update timer
        }
      }
    });

    // watch timer, and check if it needs to stop
    this.$watch(() => [this.ticker], () => this.clearTimer());

    // trigger animation for flip clock
    if (this.element.style === 'Flip clock') {
      this.$watch(() => [this.days, this.hours, this.minutes, this.seconds], (newValues, oldValues) => {
        const units = ['days', 'hours', 'minutes', 'seconds'];

        for (let i = 0; i < newValues.length; i += 1) {
          if (newValues[i] !== oldValues[i]) {
            const newBottom = document.querySelector(`.${units[i]} > .splitflap > .new-bottom`); // this flips
            const oldTop = document.querySelector(`.${units[i]} > .splitflap > .old-top`); // this flips
            const oldBottom = document.querySelector(`.${units[i]} > .splitflap > .old-bottom`);

            // manually set to old value
            oldTop.innerHTML = oldValues[i];
            oldBottom.innerHTML = oldValues[i];

            /* eslint-disable no-unused-expressions */
            // manually trigger animation
            newBottom.classList.remove('flip1');
            newBottom.offsetWidth; // For some reason this random statement is necessary lol
            newBottom.classList.add('flip1');

            oldTop.classList.remove('flip2');
            oldTop.offsetWidth; // For some reason this random statement is necessary lol
            oldTop.classList.add('flip2');
            /* eslint-enable no-unused-expressions */
          }
        }
      });
    }

    this.resizeText();
  },

  beforeUnmount() {
    clearInterval(this.intervalId);
  },

  methods: {
    getInitialCounter() {
      const { dateTime } = this.element;

      if (!this.isRelative) {
        if (!this.isCountdown) {
          return 0; // Counting up starts from zero.
        }

        const {
          dayPreview: d = 0,
          hourPreview: h = 0,
          minutePreview: m = 0,
          secondPreview: s = 0,
        } = this.element;

        // If we are counting down, we need to set the counter to the preview values.
        return (
          (d * 86400) + (h * 3600) + (m * 60) + s
        ) * 1e3;
      }

      // If we are counting down to, or counting up from a date,
      // we need to prepopulate counter.
      if (this.isCountdown && dateTime) { // Count down from date
        const now = dayjs();
        const end = dayjs(dateTime);

        if (end > now) {
          return end.diff(now, 'seconds') * 1e3;
        }

        return 0;
      }

      if (dateTime) { // Count up from date
        const now = dayjs();
        const start = dayjs(dateTime);

        if (start < now) {
          return now.diff(start, 'seconds') * 1e3;
        }

        return 0;
      }

      return 0;
    },

    timer() {
      clearInterval(this.intervalId);

      if (!this.element.playTimer) {
        // Keep track of the time elapsed when we pause the stopwatch/timer
        // We do this by adding the current duration to a separate variable,
        // then clear it.
        if (this.isCountdown) {
          this.counter -= this.ticker;
        } else {
          this.counter += this.ticker;
        }

        this.ticker = 0;
        return;
      }

      // If the timer is relative to a date, then we need to make sure `this.counter` is updated when starting the timer.
      if (this.isRelative) {
        this.counter = this.getInitialCounter();
      }

      // Grab some timestamps we need to track, and start the timer.
      this.prevMoment = dayjs();
      this.intervalId = setInterval(this.setTimer, this.element.timerType === 'Stopwatch' ? 1 : 100);
    },

    clearTimer() {
      // if timer already finished (has met criterion to stop): stop timer by setting play to false and clearing interval
      // stopwatch runs indefinitely, has no stop criteria
      const clear = () => {
        clearInterval(this.intervalId);
        this.element.playTimer = false;
        return true;
      };

      if (this.isCountdown) {
        if (this.duration <= 0) {
          return clear();
        }
      }

      // If null, user cleared the datepicker. value is only set by datepicker.
      if (this.isRelative && this.element.dateTime === null) {
        return clear();
      }

      return false;
    },

    setTimer() {
      if (this.clearTimer()) {
        return;
      }

      // Get diff, in ms since we last called setTimer, and add to duration.
      // This always increments up, and will be decremented later if using a countdown.
      const delta = dayjs().diff(this.prevMoment);
      this.ticker += delta;
      this.prevMoment = dayjs();
    },

    resetDuration() {
      // Reset duration _and_ counter, so everything reverts to zeroes (or the default if counting down).
      this.ticker = 0;
      this.counter = this.getInitialCounter();
    },

    resetTimer() {
      this.resetDuration();
    },

    resizeText() {
      const widget = document.getElementsByClassName('timer')[0];
      if (!widget) { return; }

      let currentFontSize;

      // set font size to default/saved font size
      widget.style.fontSize = `${this.element.styles.fontSize}px`;

      while (widget.scrollHeight > widget.offsetHeight || widget.scrollWidth > widget.offsetWidth) {
        if (currentFontSize <= 10 || Number.isNaN(currentFontSize)) {
          break;
        }

        currentFontSize = parseInt(widget.style.fontSize.slice(0, -2), 10);
        currentFontSize = Math.max(10, currentFontSize - 1);

        widget.style.fontSize = `${currentFontSize}px`;
      }
    },

    getTimerStyles() {
      return {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: this.element.timerType === 'Stopwatch' ? 'left' : 'center',
        gap: `${this.element.gap ?? 0}px`,
      };
    },

    getTimeStyles() {
      return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '5px',
      };
    },

    getDividerStyles() {
      return {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '5px',
      };
    },

    getTextStyles(textType) {
      const textStyles = { ...this.element.styles[textType] };

      textStyles.fontSize = `${textStyles.fontSize}px`;
      textStyles.letterSpacing = textStyles.letterSpacing
        ? `${textStyles.letterSpacing}px`
        : null;

      textStyles.backgroundColor = 'transparent';
      textStyles.lineHeight = textStyles.lineHeight ?? '100%';

      return textStyles;
    },

    getFlipStyles() {
      if (this.element.style === 'Basic') {
        return {};
      }

      const { fontSize } = this.element.styles.timerText;

      return {
        height: `${fontSize}px`,
        width: `${fontSize * 2}px`,
        backgroundColor: this.element.flipClockColor,
        top: 0,
        lineHeight: '100%',
        textAlign: 'center',
        borderRadius: '.15em',
        boxShadow: '0 0.025em 0.05em rgba(#000, .25)',
        perspective: '4.5em',
        margin: '5px',
      };
    },

    getFlapStyles(position) {
      if (this.element.style === 'Basic') {
        return {};
      }

      if (position === 'newTop') {
        return {
          backgroundColor: this.element.flipClockColor,
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '50%',
          borderRadius: '.15em .15em 0 0',
          overflow: 'hidden',
          zIndex: 2,
          borderBottom: '1px solid grey',
        };
      }

      if (position === 'newBottom') {
        return {
          backgroundColor: this.element.flipClockColor,
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          borderRadius: '.15em',
          webkitTransform: 'rotate3D(1, 0, 0, 90deg)',
          transform: 'rotate3D(1, 0, 0, 90deg)',
          webkitTransformOrigin: 'center',
          transformOrigin: 'center',
          webkitBackfaceVisibility: 'hidden',
          backfaceVisibility: 'hidden',
          zIndex: -2,
        };
      }

      if (position === 'oldTop') {
        return {
          backgroundColor: this.element.flipClockColor,
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '50%',
          borderRadius: '.15em .15em 0 0',
          webkitTransform: 'rotate3D(1, 0, 0, 0deg)',
          transform: 'rotate3D(1, 0, 0, 0deg)',
          webkitTransformOrigin: 'bottom',
          transformOrigin: 'bottom',
          webkitBackfaceVisibility: 'hidden',
          backfaceVisibility: 'hidden',
          overflow: 'hidden',
          zIndex: 3,
          borderBottom: '1px solid grey',
        };
      }

      if (position === 'oldBottom') {
        return {
          backgroundColor: this.element.flipClockColor,
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          borderRadius: '.15em',
          zIndex: -3,
        };
      }

      return {};
    },
  },
};
</script>

<style lang="scss">
.flip1 {
  -webkit-animation: flip1 1s ease-in forwards;
  animation: flip1 1s ease-in forwards;
}

.flip2 {
  -webkit-animation: flip2 1s ease-in forwards;
  animation: flip2 1s ease-in forwards;
}

@-webkit-keyframes flip1 {
  0% {
    -webkit-transform: rotate3D(1, 0, 0, 90deg);
    transform: rotate3D(1, 0, 0, 90deg);
    z-index: -2;
  }

  50% {
    -webkit-transform: rotate3D(1, 0, 0, 90deg);
    transform: rotate3D(1, 0, 0, 90deg);
    z-index: -2;
  }

  100% {
    -webkit-transform: rotate3D(1, 0, 0, 0deg);
    transform: rotate3D(1, 0, 0, 0deg);
    z-index: -2;
  }
}

@keyframes flip1 {
  0% {
    -webkit-transform: rotate3D(1, 0, 0, 90deg);
    transform: rotate3D(1, 0, 0, 90deg);
    z-index: -2;
  }

  50% {
    -webkit-transform: rotate3D(1, 0, 0, 90deg);
    transform: rotate3D(1, 0, 0, 90deg);
    z-index: -2;
  }

  100% {
    -webkit-transform: rotate3D(1, 0, 0, 0deg);
    transform: rotate3D(1, 0, 0, 0deg);
    z-index: -2;
  }
}

@-webkit-keyframes flip2 {
  0% {
    -webkit-transform: rotate3D(1, 0, 0, 0deg);
    transform: rotate3D(1, 0, 0, 0deg);
    z-index: 3;
  }

  50% {
    -webkit-transform: rotate3D(1, 0, 0, -90deg);
    transform: rotate3D(1, 0, 0, -90deg);
    z-index: 3;
  }

  100% {
    -webkit-transform: rotate3D(1, 0, 0, -90deg);
    transform: rotate3D(1, 0, 0, -90deg);
    z-index: 3;
  }
}

@keyframes flip2 {
  0% {
    -webkit-transform: rotate3D(1, 0, 0, 0deg);
    transform: rotate3D(1, 0, 0, 0deg);
    z-index: 3;
  }

  50% {
    -webkit-transform: rotate3D(1, 0, 0, -90deg);
    transform: rotate3D(1, 0, 0, -90deg);
    z-index: 3;
  }

  100% {
    -webkit-transform: rotate3D(1, 0, 0, -90deg);
    transform: rotate3D(1, 0, 0, -90deg);
    z-index: 3;
  }
}
</style>
